import { NavigateFunction } from "react-router";

import {
    FILTER_NAMES,
    FilterDropdownOptions,
    filteredExistingItems,
    QueryParams,
    ROUTES
} from "shared";

const getCompanyFilteredValues = (
    filterDropdownOptions: FilterDropdownOptions,
    params: QueryParams
) => {
    const companyFilterOptions = filterDropdownOptions[FILTER_NAMES.CompanyId];

    if (companyFilterOptions) {
        const companyValues = filteredExistingItems(
            companyFilterOptions,
            params[FILTER_NAMES.CompanyId]
        );

        return {
            filterName: FILTER_NAMES.CompanyId,
            value: companyValues
        };
    }

    return undefined;
};

const handleLogoClick = (pathname: string, navigate: NavigateFunction) =>
    pathname !== ROUTES.Dashboard && navigate(ROUTES.Dashboard);

export { getCompanyFilteredValues, handleLogoClick };
